import BaseModel from '../../../../base/base_model';
import _ from '../../../../utils/underscore';
let cashier = require('./view/cashier-btn.html');


class LoggedinCashierOnlyLayoutModel extends BaseModel {
    /**
     *
     * @param params
     */
    init(params) {
        if (params) {
            this
                ._setLayoutType(params.layoutType)
                ._setSilentMode(params.silentMode)
                ._setShowCashier(params.showCashier)
                ._setGameType(params.gametype)
                ._setGameName(params.gameName)
                ._setGameIsReal(params.isReal)
                ._setCashierOpenType(params.cashierOpenType);
        }
    }


    /**
     * Set game type will be valid only for game panel.
     *
     * @param gametype
     * @returns {WelcomeModel}
     * @private
     */
    _setGameType(gametype) {
        if (!_.isNumber(gametype)) {
            return this;
        }

        this._gametype = gametype;
        return this;
    }


    /**
     * Set game name will be valid only for game panel.
     *
     * @param gameName
     * @returns {WelcomeModel}
     * @private
     */
    _setGameName(gameName) {
        if (!_.isString(gameName)) {
            return this;
        }

        this._gameName = gameName;
        return this;
    }


    /**
     * Set game name will be valid only for game panel.
     *
     * @param isReal
     * @returns {WelcomeModel}
     * @private
     */
    _setGameIsReal(isReal) {
        if (!_.isBoolean(isReal)) {
            return this;
        }

        this._isReal = isReal;
        return this;
    }


    /**
     *
     * @param layoutType
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setLayoutType(layoutType) {
        this._layoutType = layoutType;
        return this;
    }


    /**
     *
     * @param silentMode
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setSilentMode(silentMode) {
        this._silentMode = silentMode;
        return this;
    }


    /**
     *
     * @param showCashier
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setShowCashier(showCashier) {
        this._showCashier = showCashier;
        return this;
    }


    /**
     *
     * @param cashierOpenType
     * @returns {LoggedinInlineLayoutModel}
     * @private
     */
    _setCashierOpenType(cashierOpenType) {
        this._cashierOpenType = cashierOpenType;
        return this;
    }


    /**
     * Get layout type.
     *
     * @returns {*}
     */
    getLayoutType() {
        return this._layoutType;
    }


    /**
     *
     * @returns {*}
     */
    getShowCashier() {
        return this._showCashier;
    }


    /**
     *
     * @returns {string}
     * @public
     */
    getshowCashier() {
        return this._showCashier ? cashier : '';
    }


    /**
     *
     * @returns {*}
     */
    getCashierOpenType() {
        return this._cashierOpenType;
    }


    /**
     *
     * @returns {*}
     */
    getGameType() {
        return this._gametype;
    }


    /**
     *
     * @returns {*}
     */
    getGameName() {
        return this._gameName;
    }


    /**
     *
     * @returns {*}
     */
    getIsReal() {
        return this._isReal;
    }
}

export default LoggedinCashierOnlyLayoutModel;